const popups = {
    trigersToggle: [
        {
            name: 'menu',
            open: [document.getElementById('openMenu')] as HTMLElement[],
            popup: document.getElementById('menu'),
            close: document.getElementById('closeMenu') as HTMLElement,
            overlay: true
        },
        {
            name: 'sidebar',
            open: [document.getElementById('openSidebar')] as HTMLElement[],
            popup: document.getElementById('sidebarWrap'),
            close: document.getElementById('closeSidebar') as HTMLElement,
            overlay: true
        },
        {
            name: 'search',
            open:  [document.getElementById('searchOpen')] as HTMLElement[],
            popup: document.getElementById('searchWrap'),
            close: document.getElementById('closeSearch') as HTMLElement,
            overlay: false
        },

        {
            name: 'finder',
            open:  [document.getElementById('jsOpenFinder')] as HTMLElement[],
            popup: document.getElementById('jsFinderWrap'),
            close: document.getElementById('jsCloseFinder') as HTMLElement,
            overlay: true
        },

        {
            name: 'finderDesk',
            open:  [document.getElementById('jsOpenFinderDesk')] as HTMLElement[],
            popup: document.getElementById('jsFinderWrap'),
            close: document.getElementById('jsCloseFinder') as HTMLElement,
            overlay: true
        },

        {
            name: 'ProductContactForm',
            open:  [document.getElementById('jsOpenForm')] as HTMLElement[],
            popup: document.getElementById('jsFormWrap'),
            close: document.getElementById('jsCloseForm') as HTMLElement,
            overlay: true
        }

    ],
    clearFilters: document.getElementById('clearFilters'),
    overlay: document.getElementById('overlay')! as HTMLElement,
    close: document.querySelectorAll('.jsClose'),
    activClasse: [] as HTMLElement[],
    menuAdvert: document.getElementById('phoneAdvert'),

    init() {
        this.openPopupToggle();
        this.overlayClose();
        this.clearFilter();

    },
    clearFilter() {
        if (this.clearFilters) {
            let link = window.location;
            this.clearFilters.addEventListener('click', () => {
                window.location.replace(link.origin + link.pathname);
            });
        }

    },
    overlayClose() {
        this.overlay.addEventListener('click', () => {
            this.overlay.classList.remove('activeClass');
            document.documentElement.style.overflow = 'auto';
            document.body.classList.remove('activeClass');
            this.closeAll();
        });
    },

    setOverlay(open: HTMLElement | boolean, popup: HTMLElement | null, triger: HTMLElement, overlay = false) {

        if (open && popup && triger) {
            this.closeAll();
            this.overlay.classList.remove('activeClass');
            if (overlay) {
                this.overlay.classList.add('activeClass');
            }
          
                document.documentElement.style.overflow = 'hidden';
                document.body.classList.add('activeClass');
            
            popup.classList.add('activeClass');
            triger.dataset.open = 'true';
            triger.classList.add('activeClass');
            this.activClasse.push(popup);
            this.activClasse.push(triger);
        } else {
            this.overlay.classList.remove('activeClass');
            triger.dataset.open = 'false';
            
                document.documentElement.style.overflow = 'auto';
                document.body.classList.remove('activeClass');
            
            this.closeAll();
        }
    },
    closeAll() {
        this.activClasse.forEach((item) => {
            item.classList.remove('activeClass');
            item.dataset.open = 'false';
        });
        this.activClasse = [];
    },
    openPopupToggle() {

        this.trigersToggle.forEach((item, index) => {

            if (item['open'].length > 0) {
                item['open'].forEach(el => {

                    if (item['popup'] && el) {

                        item['popup'].classList.add('init');
                        el.addEventListener('click', (e) => {
                            e.preventDefault();
                            if (el.dataset.open === 'false') {
                                this.setOverlay(true, item['popup'], el, item['overlay']);
                            } else {
                                this.setOverlay(false, item['popup'], el);
                            }
                        })
                    }
                });

                if (item['close']) {
                    item['close'].addEventListener('click', () => {

                        item['open'].forEach(el => {
                            this.setOverlay(false, item['popup'], el);
                        });
                    })
                }
            }


        });
    },


}

export default popups;